
document.addEventListener("DOMContentLoaded", () => {
    let div = document.getElementById("progress-container2");
    if (!div) {
        console.error("Element #progress-container2 not found!");
        return;
    }

    let timer_second = Number(div.getAttribute("timer-seconds")) || 3;
    let redirect_link = div.getAttribute("redirect-url");

    if (!redirect_link) {
        console.error("Missing redirect-url attribute!");
        return;
    }

    // Get the progress bar element
    let progressBar = document.getElementById("progress-bar2");
    if (!progressBar) {
        console.error("Progress bar element #progress-bar2 not found!");
        return;
    }

    startRedirect(timer_second, redirect_link, progressBar);
});

function startRedirect(timer_second, redirect_link, progressBar) {
    const redirectTime = timer_second * 1000; // Convert to milliseconds

    // Start progress bar animation
    progressBar.style.transition = `width ${redirectTime}ms linear`;
    progressBar.style.width = "100%";

    setTimeout(() => {
        console.log("Redirecting to:", redirect_link);
        window.location.href = redirect_link; // Redirect in the same tab
    }, redirectTime);
}

